export const COMMISSION_ENTITY_LABEL = "Commission configuration";
export const COMMISSION_OVERRIDE_ENTITY_LABEL = "Customer override";
export const COMMISSIONS_ENTITY_LABEL = "Commissions";
